<template lang="pug">
ValidationProvider(
  :name='$attrs.name',
  :rules='$attrs.rules'
  v-slot='{ passed, failed, errors }')
  md-field(
    v-bind='$attrs'
    v-on='$listeners',
    :class='[{ "md-error md-invalid": failed }, { "md-valid": passed }, { "mt-0": !hasLabel }]')
    label
      slot(name='label')
    slot
    slide-y-down-transition
      .md-error {{ errors.join("\n") }}
    slide-y-down-transition
      slot(v-show='failed' name='error-icon')
      md-icon.error(v-if='!hasErrorIcon' v-show='failed') close
    slide-y-down-transition
      slot(v-show='passed' name='success-icon', :passed='passed')
      md-icon.success(v-if='!hasSuccessIcon' v-show='passed') done
</template>

<script>
export default {
  name: 'ValidatedInput',
  inheritAttrs: false,
  computed: {
    hasErrorIcon () {
      return !!this.$slots['error-icon']
    },
    hasSuccessIcon () {
      return !!this.$slots['success-icon']
    },
    hasLabel () {
      return !!this.$slots['label']
    }
  }
}
</script>

<style scoped>
.md-field > .md-error {
  bottom: -10px;
}
.mt-0 {
  margin-top: 0;
}
</style>
